import React from 'react';
import classnames from 'classnames';
import Isvg from 'react-inlinesvg';
import { Link } from 'react-router-dom';
import NavLink from 'app/components/general/NavLink';
import InputGroupBlock from 'app/components/general/InputGroupBlock';

import {
  Collapse, Navbar, Nav, NavItem, Tooltip,
} from 'reactstrap';
import TeammoLogo from 'app/images/logo-white.svg';

import JoinIcon from 'app/images/icons/plus.svg';
import ProfileIcon from 'app/images/icons/person.svg';
import HelpIcon from 'app/images/icons/help.svg';
import LogoutIcon from 'app/images/icons/logout.svg';
import DownArrow from 'app/images/icons/down-arrow.svg';
import DotsIcon from 'app/images/icons/dots.svg';
import EventsIcon from 'app/images/icons/events.svg';
import OverviewIcon from 'app/images/icons/reports.svg';
import TeamIcon from 'app/images/icons/team.svg';
import TeamsIcon from 'app/images/icons/teams.svg';
import RequestIcon from 'app/images/icons/request.svg';
import ReportsIcon from 'app/images/icons/reports.svg';
import ClipboardIcon from 'app/images/icons/clipboard.svg';

interface INavBarProps {
  actions: any;
  match: any;
  teams: any;
  users: any;
  teamName: string;
  teamId: string;
  clubs: any;
  clubName: string;
  clubId: string;
  authentication: any;
  anonymous: boolean;
}

class NavBar extends React.Component<INavBarProps> {
  static defaultProps = {
    actions: {},
    users: {},
    match: {},
    teams: {},
    teamName: '',
    teamId: '',
    clubs: {},
    clubName: '',
    clubId: '',
    anonymous: true,
  };

  render(): React.ReactNode {
    return (
      <Navbar className="side-bar">
        <Link className="navbar-brand" to="/dashboard">
          <Isvg className="header-logo" alt="Teammo" src={TeammoLogo} />
        </Link>
        <Collapse navbar>
          <Nav className="" navbar>
            <div className="nav-top">
              {this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/join-team'
                      || this.props.match.path === '/:teamCode',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={JoinIcon} />
                    <span className="nav-link-text">Join Team</span>
                  </NavLink>
                </NavItem>
              )}
              {!this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/:teamMemberCode/overview'
                        || this.props.match.path === '/:teamCode/:teamMemberCode',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={OverviewIcon} />
                    <span className="nav-link-text">Team Overview</span>
                  </NavLink>
                </NavItem>
              )}
              {/* {!this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/:teamMemberCode/your-details',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={ProfileIcon} />
                    <span className="nav-link-text">Your Details</span>
                  </NavLink>
                </NavItem>
              )} */}
              {/* {!this.props.anonymous && (
                <NavItem>
                  <NavLink
                    className={classnames({
                      active:
                        this.props.match.path === '/:teamCode/:teamMemberCode/payment-history',
                    })}
                    to="/"
                  >
                    <Isvg className="nav-link-icon" src={RequestIcon} />
                    <span className="nav-link-text">Payment History</span>
                  </NavLink>
                </NavItem>
              )} */}
            </div>
            <div className="nav-bottom">
              <NavItem>
                <a
                  className="nav-link"
                  href="https://help.teammo.com.au/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Isvg className="nav-link-icon" src={HelpIcon} />
                  <span className="nav-link-text">Help & Support</span>
                </a>
              </NavItem>
            </div>
          </Nav>
        </Collapse>
      </Navbar>
    );
  }
}
export default NavBar;
